import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { InputGroupPropsTypes } from "../../components/inputComp/InputGroupType";
//import InputGroup from "../../../inputComp/InputGroup";
import InputGroup from "../../components/inputComp/InputGroup";
import {
  AddressIcon,
  CloseIcon,
  DepartmentIcon,
  EmailIcon,
  FaxIcon,
  IdIcon,
  MobileIcon,
  NameIcon,
  PasswordIcon,
  SearchIcon,
} from "../../components/iconSet/IconSet";
import LoadingScreen from "../../components/loadingScreenComp/LoadingScreen";
//import { Role, RoleInterface, DepartmentOption } from "../../components/RoleTypes";
import axios from "axios";
import AlertDialog from "../../components/popupComp/AlertDialog";
import { useUserData } from "../../context/UserDataContext";

const ChangePassword = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [alertDialogState, setAlertDialogState] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertDescription, setAlertDescription] = useState("");
  const [alertCallback, setAlertCallback] = useState<() => void | undefined>();

  const showAlertDialog = (
    title: string,
    description: string,
    callback?: () => void
  ) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertCallback(() => callback); // wrap in function to preserve reference
    setAlertDialogState(true);
  };

  const [isUpdate, setIsUpdate] = useState(false);

  const { username } = useUserData()

  const passwordRef = useRef<HTMLInputElement | null>(null);
  const confirmPasswordRef = useRef<HTMLInputElement | null>(null);
  const currentPasswordRef = useRef<HTMLInputElement | null>(null);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [refreshKey, setRefreshKey] = useState(0);

  const [formData, setFormData] = useState({
    password: "",
    newPassword: "",
  });

  const handleChangePassword = async (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.preventDefault();

    // const userDetails = sessionStorage.getItem("userdetails");
    // if (!userDetails) {
    //   showAlertDialog("Error", "User is not logged in.");
    //   return;
    // }

    // const { username } = JSON.parse(userDetails);

    const currentPassword = currentPasswordRef.current?.value || "";
    const newPassword = passwordRef.current?.value || "";
    const confirmPassword = confirmPasswordRef.current?.value || "";

    //console.log("username: "+ username + "current PassWord: " + currentPassword+"new password: "+ newPassword + "confirm password: " + confirmPassword);

    if (!currentPassword || !newPassword || !confirmPassword) {
      showAlertDialog("Validation Error", "Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      showAlertDialog(
        "Password Mismatch",
        "New and confirm password do not match."
      );
      return;
    }

    try {
      const response = await axios.put(`${BASE_URL}/identity_manager/api/v1/resetpassword`, {
        username,
        password: currentPassword,
        newPassword: newPassword,
      });

      if (response.status === 200) {
        showAlertDialog("Success", "Password changed successfully.");
        // Optionally clear input values
        if (currentPasswordRef.current) currentPasswordRef.current.value = "";
        if (passwordRef.current) passwordRef.current.value = "";
        if (confirmPasswordRef.current) confirmPasswordRef.current.value = "";
      }
    } catch (error: any) {
      if (error.response) {
        showAlertDialog(
          "Error",
          /* error.response.data || "Something went wrong." */
          "Something went wrong."
        );
      } else {
        showAlertDialog("Error", "Network or server error.");
      }
    }
  };

  const formItems: InputGroupPropsTypes[] = [
    {
      type: "password",
      icon: <PasswordIcon width="1.5rem" color="var(--color-main-white)" />,
      color: "var(--color-accent-bg)",
      placeholder: "Enter Current Password",
      label: "current password",
      name: "password",
      //value: form.password,
      componentInputElement: currentPasswordRef,
      required: true,
      //onChange: handleChange,
      //disabled: isUpdate ? true : false,
    },
    {
      type: "password",
      icon: <PasswordIcon width="1.5rem" color="var(--color-main-white)" />,
      color: "var(--color-accent-bg)",
      placeholder: "Enter Password",
      label: "password",
      name: "newPassword",
      //value: form.password,
      componentInputElement: passwordRef,
      required: true,
      //onChange: handleChange,
      //disabled: isUpdate ? true : false,
    },
    {
      type: "password",
      icon: <PasswordIcon width="1.5rem" color="var(--color-main-white)" />,
      color: "var(--color-accent-bg)",
      placeholder: "Enter Confirm Password",
      label: "confirm password",
      name: "confirm_password",
      componentInputElement: confirmPasswordRef,
      required: true,
      //onChange: handleChange
      //disabled: isUpdate ? true : false,
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    setIsLoading(false);
  }, []);

  return (
    <div className="container-wrapper">
      <span className="title">Change Password</span>
      <div className="create-department">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="grid-layout-create-department"
        >
          <div
            style={{
              width: "60%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
            className=""
          >
            <div className="left-side">
              {formItems.slice(0, 3).map((field, index) => (
                <InputGroup key={index} {...field} />
              ))}
            </div>

            <div className="button-wrapper" style={{ gridArea: "button" }}>
              <div className="left-side"></div>
              <div className="right-side">
                <button
                  className="button-normal"
                  onClick={handleChangePassword}
                >
                  Change Password
                  {/* {isUpdate ? "Update" : "Create"} */}
                </button>
              </div>
            </div>
          </div>
          {alertDialogState && (
            <AlertDialog
              title={alertTitle}
              description={alertDescription}
              windowState={alertDialogState}
              setWindowState={setAlertDialogState}
              function={alertCallback}
            />
          )}
        </div>
      </div>
      {isLoading ? <LoadingScreen /> : null}
    </div>
  );
};

export default ChangePassword;
